import { styled } from 'baseui'
import { lightTheme } from '@/customTheme'

const WrapSwatch = styled('div', (props: { $active: boolean; $color: string; $isSecondaryStyle?: boolean; $isTransparent?: boolean }) => ({
  width: props.$isSecondaryStyle ? '32px' : '40px',
  height: props.$isSecondaryStyle ? '32px' : '40px',
  borderRadius: '50%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  boxSizing: 'border-box',
  borderWidth: props.$active ? `${props.$isSecondaryStyle ? 3 : 4}px !important` : '2px',
  background: (!props.$isTransparent && props.$active) ? 'white !important' : '',
  borderStyle: 'solid',
  transition: 'all 0.25s ease-in-out',
  ':hover': {
    cursor: 'pointer',
    transform: props.$active ? '' : 'scale(1.1)',
  },
  borderColor: props.$color,
  // Transparent active: inset white gap + inner gray ring via box-shadow, no second element needed
  ...(props.$isTransparent && props.$active
    ? {
        boxShadow: props.$isSecondaryStyle
          ? `inset 0 0 0 3px white, inset 0 0 0 4px ${props.$color}`
          : `inset 0 0 0 4px white, inset 0 0 0 5px ${props.$color}`,
      }
    : {}),
}))

const InnerDot = styled('div', (props: { $color: string; $active: boolean; $isSecondaryStyle?: boolean }) => ({
  width: props.$isSecondaryStyle ? '20px' : '24px',
  height: props.$isSecondaryStyle ? '20px' : '24px',
  borderRadius: '50%',
  borderWidth: props.$color === lightTheme.colors.grayScale100 && !props.$active ? 0 : '1px',
  borderStyle: 'solid',
  borderColor: props.$color,
}))

export interface ColorSwatchButtonProps {
  color: string
  isActive: boolean
  onClick: (color: string) => void
  isSecondaryStyle?: boolean
}

const CHECKERBOARD = {
  backgroundImage: 'repeating-conic-gradient(#e0e0e0 0% 25%, #ffffff 0% 50%)',
  backgroundSize: '12px 12px',
  backgroundPosition: 'center',
  backgroundOrigin: 'border-box' as const,
} as const

function ColorSwatchButton({ color, isActive, onClick, isSecondaryStyle }: ColorSwatchButtonProps) {
  const isTransparent = color === 'transparent'
  const isWhite = !isTransparent && color.toLowerCase() === '#ffffff'
  const borderColor = (isTransparent || isWhite) ? lightTheme.colors.grayScale100 : color

  return (
    <WrapSwatch
      $active={isActive}
      $color={borderColor}
      $isSecondaryStyle={isSecondaryStyle}
      $isTransparent={isTransparent}
      onClick={() => onClick(color)}
      style={isTransparent ? CHECKERBOARD : { background: color }}
    >
      {!isTransparent && (
        <InnerDot
          $active={isActive}
          $color={borderColor}
          $isSecondaryStyle={isSecondaryStyle}
          style={{ background: color }}
        />
      )}
    </WrapSwatch>
  )
}

export default ColorSwatchButton
